import React from 'react';
import './CommunityForums.css'; // Ensure the CSS file is correctly linked
import { Helmet } from 'react-helmet'; // Import Helmet

function CommunityForums() {
    return (
        <div className="community-forums">
            <Helmet>
                <title>RCScouting Forums - Discuss, Share, and Learn with Fellow Rocket League Enthusiasts</title>
                <meta name="description" content="Engage in the RCScouting community forums. Discuss strategies, share your experiences, and connect with other Rocket League fans and players." />
            </Helmet>
            <h1>Community Forums</h1>
            <div className="forum-content">
                <h2>General Discussion</h2>
                <ul className="forum-list">
                    <li className="forum-topic">
                        <h3>Topic: Best Strategies for New Players</h3>
                        <p>Posts: 34</p>
                    </li>
                    <li className="forum-topic">
                        <h3>Topic: Upcoming Tournaments 2024</h3>
                        <p>Posts: 27</p>
                    </li>
                    {/* Add more topics here */}
                </ul>
                <div className="post-new-topic">
                    <h3>Start a New Topic</h3>
                    <textarea placeholder="Write your topic..."></textarea>
                    <button>Post Topic</button>
                </div>
            </div>
        </div>
    );
}

export default CommunityForums;
